import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

// Removed individual caching logic, now handled by axiosConfig interceptors

const settingsApi = {
  getSettings: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ALL_SETTINGS);
      return response.data;
    } catch (error) {
      console.error('Error fetching all settings:', error);
      throw error;
    }
  },

  getSettingByKey: async (key) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.SETTINGS(key));
      return response.data;
    } catch (error) {
      console.error(`Error fetching setting for key ${key}:`, error);
      throw error;
    }
  },
};

export default settingsApi;